<template>
  <div>
    <div class="custom-bg p-3 rounded mt-4">
      <section-title
        class="section-title__extended mt-4"
        content="Evaluadores"
        icon="fas fa-laptop text-orange"
        reverse
      />
      <div class="row">
        <div class="d-flex col-12">
          <custom-drop-down
            v-model="selectedEvaluator"
            class="w-25 mr-2"
            :disabled="readOnly"
            fieldkey="userId"
            fieldname="fullName"
            :options="availableEvaluators"
            placeholder="Seleccione"
          />

          <action-button
            :disabled="readOnly"
            i="fas fa-user-plus"
            text="Asignar"
            variant="success mr-3 px-3"
            @click="assignEvaluator"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <section-title
          class="section-title__extended mt-4"
          content="Información de Evaluadores"
        />
      </div>

      <div class="col-12 my-2">
        <slot name="evaluator-error" />
      </div>

      <template v-if="model && model?.length">
        <div
          v-for="(item, idx) in model"
          :key="item.userId || idx"
          class="col-12 my-2"
        >
          <div class="col-12 my-2">
            <div
              class="row custom-bg p-3 rounded align-items-center evaluator-row"
            >
              <div class="col-lg-3 col-md-4 col-12">
                <div class="d-flex flex-column h-100 justify-content-center">
                  <span class="text-muted d-block font-14 mb-0">Nombre:</span>
                  <span class="font-16 color-black  text-truncate mb-0">
                    {{ item.fullName }}
                  </span>
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-12 mt-2 mt-md-0">
                <div class="d-flex flex-column h-100 justify-content-center">
                  <span class="text-muted d-block font-14 mb-0">Usuario:</span>
                  <span class="font-16 color-black  text-truncate mb-0">
                    {{ item.userName }}
                  </span>
                </div>
              </div>

              <div class="col-lg-3 col-md-4 col-12 mt-2 mt-md-0">
                <div class="d-flex align-items-center h-100">
                  <check-box
                    v-model="item.isSpecialized"
                    class="row-check"
                    :disabled="readOnly"
                    text="Evaluador Especializado"
                    @input="setExclusive(idx, $event)"
                  />
                </div>
              </div>

              <div
                v-if="!readOnly"
                class="d-flex col-lg-3 col-12 justify-content-lg-end mt-2 mt-lg-0"
              >
                <action-button
                  i="fas fa-times-circle"
                  text="Remover"
                  variant="outline-danger mr-3 px-3"
                  @click="removeAt(idx)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>

      <div v-else class="col-12">
        <custom-result-not-found />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import alertMixin from '@/mixins/alert.mixin.js';

export default {
  name: 'Evaluator',
  components: {
    SectionTitle,
    CustomResultNotFound,
    CustomDropDown,
    ActionButton,
    CheckBox,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    evaluators: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedEvaluator: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    availableEvaluators() {
      return this.evaluators.filter(
        (e) => !this.model.some((m) => m.userId === e.userId)
      );
    },
    regularEvaluatorsCount() {
      return this.model.filter((e) => !e.isSpecialized).length;
    },
  },
  methods: {
    assignEvaluator() {
      if (!this.selectedEvaluator) {
        this.ShowToast('', 'Debe seleccionar un evaluador.', 'error');
        return;
      }
      this.model = [...this.model, { ...this.selectedEvaluator }];
      this.selectedEvaluator = null;
    },

    removeAt(idx) {
      const copy = this.model.slice();
      copy.splice(idx, 1);
      this.model = copy;
    },
    setExclusive(index, val) {
      if (!val) return;
      this.model = this.model.map((e, i) => ({
        ...e,
        isSpecialized: i === index,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.section-title__extended ::v-deep {
  .dot {
    background-color: #fff !important;
  }
}
.custom-bg {
  background-color: #f7f7f7;
}
</style>
